<!--动态面板-->
<template>
  <div class="qk-dynamic-panel">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "QkDynamicPanel", // 这个名字很重要，它就是未来的标签名
  props: {},
};
</script>

<style lang="scss" scoped></style>
